import {
  CreateDealPrice,
  IGetAllConditionTypeParams,
  IGetOrderParams,
  IGetOrderProcessParams,
  IGetOrderTempByIdParams,
  IGetStatusOrder,
  IUpdateOrderTempParams,
} from 'interfaces/SalesInfo';

export const SALES_INFO_VARIABLES = {
  getGoldSoldBuyOrder: (orderId: string) => {
    return { input: { orderId } };
  },
  getCustomer: (customerId: string) => {
    return {
      input: { id: { equals: customerId } },
    };
  },
  getOrder: (params: IGetOrderParams) => {
    return {
      input: {
        orderId: params.orderId,
        orderTypeId: params.orderTypeId,
      },
    };
  },
  getAllConditionTypes: (params: IGetAllConditionTypeParams) => {
    const page = params?.page;
    const pageSize = params?.pageSize;

    return {
      ...(page && pageSize && { skip: (page - 1) * pageSize }),
      ...(pageSize && { take: pageSize }),
      input: {
        id: { contains: params?.conditionTypeId ?? '' },
      },
    };
  },
  getOrderProcess: (params: IGetOrderProcessParams) => {
    return {
      input: {
        orderId: {
          equals: params.orderId,
        },
        processStatus: {
          value: {
            equals: params.processStatus,
          },
        },
      },
    };
  },
  getCustomerList: (customerId: string) => {
    return { input: { customerId } };
  },
  updateOrderTemp: (params: IUpdateOrderTempParams) => {
    return {
      input: {
        id: params.id,
        customerId: params.customerId,
        childCustomerId: params.childCustomerId,
      },
    };
  },
  getOrderTempById: (params: IGetOrderTempByIdParams) => {
    const { plantId, teamSalesId, searchValue } = params;

    return {
      skip: params?.page ?? 0,
      take: params?.pageSize ?? 10,
      input: {
        // teamTypeId: 'A103_01',
        customerId: params.customerId,
        orderTypeId: params.orderTypeId,
        ...(searchValue && { orderId: searchValue.trim() }),
        ...(searchValue && { teamSalesId: searchValue.trim() }),
        ...(plantId && { plantId: plantId }),
        ...(teamSalesId && { teamSalesId: teamSalesId }),
      },
    };
  },
  getOrderDealPrice: (orderId: string) => {
    return {
      input: {
        id: orderId,
      },
    };
  },
  getOrderStatusComboBox: (params: IGetStatusOrder) => {
    return {
      input: {
        groupId: { equals: params.groupId },
        ...(params.id && { id: { not: params.id } }),
      },
    };
  },
  createDealPrice: (params: CreateDealPrice) => {
    return { input: params };
  },
};
